/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage In order to see the config changes in the template.
 * ! To clear local storage: (https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/).
 */ "use strict";
// JS global variables
window.config = {
    colors: {
        primary: "#7367f0",
        secondary: "#a8aaae",
        success: "#28c76f",
        info: "#00cfe8",
        warning: "#ff9f43",
        danger: "#ea5455",
        dark: "#4b4b4b",
        black: "#000",
        white: "#fff",
        cardColor: "#fff",
        bodyBg: "#f8f7fa",
        bodyColor: "#6f6b7d",
        headingColor: "#5d596c",
        textMuted: "#a5a3ae",
        borderColor: "#dbdade"
    },
    colors_label: {
        primary: "#7367f029",
        secondary: "#a8aaae29",
        success: "#28c76f29",
        info: "#00cfe829",
        warning: "#ff9f4329",
        danger: "#ea545529",
        dark: "#4b4b4b29"
    },
    colors_dark: {
        cardColor: "#2f3349",
        bodyBg: "#25293c",
        bodyColor: "#b6bee3",
        headingColor: "#cfd3ec",
        textMuted: "#7983bb",
        borderColor: "#434968"
    },
    enableMenuLocalStorage: true // Enable menu state with local storage support
};
window.assetsPath = document.documentElement.getAttribute("data-assets-path");
window.templateName = document.documentElement.getAttribute("data-template");
window.rtlSupport = true; // set true for rtl support (rtl + ltr), false for ltr only.
/**
 * TemplateCustomizer
 * ! You must use(include) template-customizer.js to use TemplateCustomizer settings
 * -----------------------------------------------------------------------------------------------
 */ // To use more themes, just push it to THEMES object.
/* TemplateCustomizer.THEMES.push({
  name: 'theme-raspberry',
  title: 'Raspberry'
}); */ // To add more languages, just push it to LANGUAGES object.
/*
TemplateCustomizer.LANGUAGES.fr = { ... };
*/ /**
 * TemplateCustomizer settings
 * -------------------------------------------------------------------------------------
 * cssPath: Core CSS file path
 * themesPath: Theme CSS file path
 * displayCustomizer: true(Show customizer), false(Hide customizer)
 * lang: To set default language, Add more langues and set default. Fallback language is 'en'
 * controls: [ 'rtl', 'style', 'headerType', 'contentLayout', 'layoutCollapsed', 'layoutNavbarOptions', 'themes' ] | Show/Hide customizer controls
 * defaultTheme: 0(Default), 1(Bordered), 2(Semi Dark)
 * defaultStyle: 'light', 'dark', 'system' (Mode)
 * defaultTextDir: 'ltr', 'rtl' (rtlSupport must be true for rtl mode)
 * defaultContentLayout: 'compact', 'wide' (compact=container-xxl, wide=container-fluid)
 * defaultHeaderType: 'static', 'fixed' (for horizontal layout only)
 * defaultMenuCollapsed: true, false (For vertical layout only)
 * defaultNavbarType: 'sticky', 'static', 'hidden' (For vertical layout only)
 * defaultFooterFixed: true, false (For vertical layout only)
 * defaultShowDropdownOnHover : true, false (for horizontal layout only)
 */ if (typeof TemplateCustomizer !== "undefined") window.templateCustomizer = new TemplateCustomizer({
    cssPath: assetsPath + "vendor/css" + (rtlSupport ? "/rtl" : "") + "/",
    themesPath: assetsPath + "vendor/css" + (rtlSupport ? "/rtl" : "") + "/",
    displayCustomizer: true,
    lang: localStorage.getItem("templateCustomizer-" + templateName + "--Lang") || "en",
    // defaultTheme: 2,
    // defaultStyle: 'system',
    // defaultTextDir: 'rtl',
    // defaultContentLayout: 'wide',
    // defaultHeaderType: 'static',
    // defaultMenuCollapsed: true,
    // defaultNavbarType: 'sticky',
    // defaultFooterFixed: false,
    // defaultShowDropdownOnHover: false,
    controls: [
        "rtl",
        "style",
        "headerType",
        "contentLayout",
        "layoutCollapsed",
        "layoutNavbarOptions",
        "themes"
    ]
});

//# sourceMappingURL=index.fec92eee.js.map
